<input
  type="range"
  class="form-control-range"
  [ngClass]="cssClass"
  [min]="min"
  [max]="max"
  [step]="step"
  [value]="value"
  (input)="inputEvent.emit($event)"
  (change)="changeEvent.emit($event)"
/>
